export const main = {
	yhxm:'Tên Người Dùng',
	qrxx:'Xác Nhận Việc Điền Thông Tin',
    mmdl:'Đăng Nhập Bằng Mật Khẩu',
    yzmdl:'Đăng Nhập Bằng Mã Xác Minh',
    sjhm:"Số Điện Thoại Di Động",
    qsrmm:'Vui Lòng Nhập Mật Khẩu',
    wjmm:'Quên Mật Khẩu',
    dl:'Đăng Nhập',
    zcxzh:'Đăng Ký Tài Khoản Mới',
    yzm:'Mã Xác Minh',
    hqyzm:'Lấy Mã Xác Minh',
    sryx:'Nhập Email',
    zcsrmm:'Nhập Mật Khẩu Lại',
    yqm:'Vui Lòng Nhập Mã Mời/Số Điện Thoại Người Mời',
    sjyz:'Xác Minh Điện Thoại',
    yxyz:'Xác Minh Email',
    tyxyhzc:'Tôi Đồng Ý Với Điều Khoản Dịch Vụ và Chính Sách Riêng Tư',
    ty:'Tôi Đã Đọc Và Đồng Ý',
    yhxy:'Điều Khoản Dịch Vụ Người Dùng',
    yszc:'Chính Sách Riêng Tư',
    zce:'Đăng Ký',
    zyzhljdl:'Đã Có Tài Khoản, Đăng Nhập Ngay',
    wdzc:'Tài Sản Của Tôi',
    wdzh:'Tài Khoản Của Tôi',
    tbgl:'Quản Lý Đồng Bộ',
    fbxh:'Đăng Bài Tín Hiệu',
    xhsc:'Thị Trường Tín Hiệu',
    czsc:'Hướng Dẫn Sử Dụng',
    tcxh:'Rời Khỏi Tín Hiệu',
    ye:'Số Dư',
    jz:'Giá Trị Thanh Lọc',
    jyss:'Số Lô Giao Dịch',
    ccyl:'Lãi Từ Vị Trí Giữ',
    xvh:'Số Thứ Tự',
    sftb:'Có Đồng Bộ Không',
    fwq:'Máy Chủ',
    zh:'Tài Khoản',
    zyk:'Tổng Lãi Lỗ',
    kds:'Số Lệnh Mở',
    zhzt:'Trạng Thái Tài Khoản',
    cz:'Thao Tác',
    s:'Có',
    f:'Không',
    zc:'Bình Thường',
    yc:'Nghịch Thường',
    ck:'Xem',
    cpyk:'Lãi Lỗ Sản Phẩm',
    zss:'Tổng Số Lô',
    jypz:'Loại Sản Phẩm Giao Dịch',
    sy:'Thu Nhập',
    sszb:'Tỷ Lệ Số Lô',
    cczh:'Tổng Hợp Vị Trí Giữ',
    ddh:'Số Lệnh',
    jyl:'Khối Lượng Giao Dịch',
    kcsj:'Thời Gian Mở Vị Trí',
    kcjg:'Giá Mở Vị Trí',
    bjjg:'Giá Đánh Dấu',
    zyzs:'Chốt Lãi/Cắt Lỗ',
    gylx:'Lãi Suất Đầu Đêm',
    yk:'Lãi Lỗ',
    xzcksj:'Vui Lòng Chọn Dữ Liệu Muốn Xem Trong Tài Khoản',
    tbyk:'Đồng Bộ Lãi Lỗ',
    ccsj:'Thời Gian Giữ Vị Trí',
    pcsj:'Thời Gian Đóng Vị Trí',
    tjzh:'Thêm Tài Khoản',
    bz:'Ghi Chú',
    sfwxh:'Có Phải Là Tín Hiệu Không',
    tbzt:'Trạng Thái Đồng Bộ',
    ytb:'Đã Đồng Bộ',
    wtb:'Chưa Đồng Bộ',
    qyjy:'Kích Hoạt/Vô Hiệu Hóa',
    yqy:'Đã Kích Hoạt',
    yjy:'Đã Vô Hiệu Hóa',
    xgzhmm:'Sửa Mật Khẩu',
    gbxh:'Đóng Tín Hiệu',
    sczh:'Xóa Tài Khoản',
    qw:'Đi Đến',
    y:'Trang',
    tjglzh:'Thêm Tài Khoản Liên Kết',
    qxz:'Vui Lòng Chọn',
    qsrzh:'Vui Lòng Nhập Tài Khoản',
    mm:'Mật Khẩu',
    qsrbz:'Vui Lòng Nhập Ghi Chú',
    sjsqxhts:'Quyền Otorisasi Mật Khẩu Chủ Tài Khoản Thực Có Thể Nâng Cấp Thành Tín Hiệu Cộng Đồng',
    qr:'Xác Nhận',
    qx:'Hủy',
    zhjy:'Tài Khoản ***** Có Đặt Thành Trạng Thái Vô Hiệu Hóa Không',
    zhqy:'Tài Khoản ***** Có Đặt Thành Trạng Thái Kích Hoạt Không',
    dqdlmm:'Mật Khẩu Đăng Nhập Hiện Tại',
    xzhmm:'Mật Khẩu Tài Khoản Mới',
    qrxmm:'Xác Nhận Mật Khẩu Mới',
    qsrdqdlmm:'Vui Lòng Nhập Mật Khẩu Đăng Nhập Hiện Tại',
    qsrxmm:'Vui Lòng Nhập Mật Khẩu Mới',
    qzcsrxmm:'Vui Lòng Nhập Mật Khẩu Mới Lại',
    yhzl:'Thông Tin Người Dùng',
    jcxx:'Thông Tin Cơ Bản',
    tx:'Hình Đại Diện',
    sczp:'Tải Lên Hình Ảnh',
    tudxxz:'Vui Lòng Chọn Hình Ảnh Để Tải Lên: Kích Thước 413x626 Pixel, Hỗ Trợ Định Dạng JPG, PNG, V.v., Kích Thước Hình Ảnh Phải Nhỏ Hơn 2M',
	
	
    gjhdq:'Quốc Gia và Khu Vực',
    dzyx:'Email',
    bcxg:'Lưu Thay Đổi',
    zhaq:'Bảo Mật Tài Khoản',
    dqmm:'Mật Khẩu Hiện Tại',
    xmm:'Mật Khẩu Mới',
    qrmm:'Xác Nhận Mật Khẩu',
    qsrdqmm:'Vui Lòng Nhập Mật Khẩu Hiện Tại',
    qd:'Xác Định',
    tjtb:'Thêm Đồng Bộ',
    tb:'Đồng Bộ',
    xh:'Tín Hiệu',
    qsrnr:'Vui Lòng Nhập Nội Dung',
    tbzh:'Tài Khoản Đồng Bộ',
    qxztbzh:'Vui Lòng Chọn Tài Khoản Đồng Bộ (Chọn Nhiều)',
    jygz:'Quy Tắc Giao Dịch',
    bzjdb:'Tỷ Lệ Đảm Bảo',
    jzdb:'Tỷ Lệ Giá Trị Thanh Lọc',
    kyzjdb:'Tỷ Lệ Tiền Phương Tiện Sẵn Sàng Dùng',
    jyldb:'Tỷ Lệ Khối Lượng Giao Dịch',
    gdssdb:'Tỷ Lệ Số Lô Cố Định',
    jycs:'Tham Số Giao Dịch',
    kcjybc:'Bồi Thường Giá Mở Vị Trí Tốt Hơn',
    xhsxzdpc:'Đóng Vị Trí Tự Động Khi Tín Hiệu Không Hiệu Lực',
    zdss:'Số Lô Tối Đa',
    zdhc:'Rút Lùi Tối Đa',
    jsbz:'Tất Cả Dựa Trên Hợp Đồng Tiêu Chuẩn Quốc Tế Để Tính Toán (Hợp Đồng Tiêu Chuẩn Quốc Tế Cặp Tiền Tệ 100000; Hợp Đồng Tiêu Chuẩn Quốc Tế Vàng 100 Âm; Hợp Đồng Tiêu Chuẩn Quốc Tế Bạc 5000 Âm; Hợp Đồng Tiêu Chuẩn Quốc Tế Dầu Thô 1000 Thùng)',
    pctbts:'Đóng Vị Trí Một Phần Và Hoạt Động Đóng Vị Trí Dựa Trên Quy Tắc Hoạt Động Terminal Nền Tảng Khác Nhau, Quá Trình Đồng Bộ Tạm Thời Chưa Hỗ Trợ, Xin Vui Lòng Biết Đến',
    tbxh:'Tín Hiệu Đồng Bộ',
    tbms:'Chế Độ Đồng Bộ',
    tbxs:'Hệ Số Đồng Bộ',
    tbsz:'Cấu Hình Đồng Bộ',
    xgcs:'Sửa Tham Số',
    yzttb:'Đồng Bộ Đã Tạm Dừng',
    ykqtb:'Đồng Bộ Đã Mở',
    sctb:'Xóa Đồng Bộ',
    xgtbcs:'Sửa Tham Số Đồng Bộ',
    cgtbzt:'Sửa Trạng Thái Đồng Bộ',
    sfqkzhdtb:'Có Mở Hoạt Động Đồng Bộ Của Tài Khoản ******* Hiện Tại Không？',
    sfztzhdtb:'Có Tạm Dừng Hoạt Động Đồng Bộ Của Tài Khoản ******* Hiện Tại Không？',
    tjxh:'Thêm Tín Hiệu',
    nsyl:'Tỷ Suất Lợi Nhuận Hàng Năm',
    zt:'Trạng Thái',
    dyz:'Người Đăng Ký Theo Dõi',
    kstbsj:'Thời Gian Bắt Đầu Đồng Bộ',
    zwsj:'Chưa Có Dữ Liệu',
    xzzh:'Chọn Tài Khoản',
    qxzzh:'Vui Lòng Chọn Tài Khoản',
    qqdxhhtbzzt:'Vui Lòng Xác Định Trạng Thái Tín Hiệu Và Người Đồng Bộ Của Bạn, Để Tránh Rủi Ro Vòng Lặp Vô Hạn',
    xhm:'Tên Tín Hiệu',
    qsrxhm:'Vui Lòng Nhập Tên Tín Hiệu (tối đa mười lăm ký tự)',
    xhmts:'Tên Tín Hiệu: Một Tài Khoản Phù Hợp Với Một Tên Tín Hiệu, Sau Khi Xác Nhận Không Thể Sửa Đổi',
    gszzdjz:'Giá Trị Thanh Lọc Tối Thiểu Của Người Theo Dõi',
    sfgkxh:'Có Công Khai Tín Hiệu Không',
    gk:'Công Khai',
    sm:'Riêng Tư',
    gsddzs:'Ghi Chú Đơn Hàng Người Theo Dõi',
    gsddzsts:'Nội Dung Bạn Điền Ở Đây Sẽ Hiển Thị Tại Địa Điểm Ghi Chú Đơn Hàng MT Của Tất Cả Người Theo Dõi',
    jdzyjgyhkf:'Chỉ Mở Cửa Cho Người Dùng Chuyên Nghiệp/Tổ Chức',
    xhms:'Mô Tả Tín Hiệu',
    shili:'Ví Dụ: Tài Khoản Này Chủ Yếu Làm Giao Dịch Ngắn Kỳ, Đơn Hàng Trong Ngày, Mỗi Đơn Đều Có Chốt Lãi/Cắt Lỗ, Khuyến Nghị Đồng Bộ Số Lô 1:1 Với 2000 Đô La Mỹ！',
    clmsts:'Để Bảo Vệ Riêng Tư Của Tất Cả Người Dùng, Mô Tả Chiến Lược Không Cho Phép Chứa Bất Kỳ Thông Tin Liên Hệ Nào',
    xhlb:'Danh Sách Tín Hiệu',
    xhlbts:'Ghi Chú: Người Cung Cấp Tín Hiệu Toàn Bộ Là Người Dùng Thứ Ba, Dịch Vụ Đồng Bộ Có Thể Xảy Ra Trễ, Tất Cả Dữ Liệu Giao Dịch Đều Thu Thập Từ Máy Chủ MT4/MT5',
    xhy:'Nguồn Tín Hiệu',
    zongsyl:'Tổng Tỷ Suất Lợi Nhuận',
    zhousyl:'Tỷ Suất Lợi Nhuận Tuần',
    jqtjycs:'Số Lần Giao Dịch 7 Ngày Gần Đây',
    irrqzsy:'Thu Nhập Trọng Số IRR',
    zdhc2:'Rút Lùi Tối Đa (%)',
    zq:'Chu Kỳ (Ngày)',
    jbsj:'Dữ Liệu Cơ Bản',
    fx:'Chia Sẻ',
    sc:'Yêu Thích/ Lưu',
    ysc:'Đã Yêu Thích/Đã Lưu',
    zsy:'Tổng Thu Nhập',
    zrj:'Tổng Số Tiền Nạp',
    zcj:'Tổng Số Tiền Rút',
    zdhcl:'Tỷ Lệ Rút Lùi Tối Đa (Giá Trị)',
    zdfk:'Lỗ Lơ Lửng Tối Đa',
    zdds:'Tổng Số Đơn Hàng',
    dbzdjyl:'Khối Lượng Giao Dịch Tối Đa Mỗi Giao Dịch',
    t:'Ngày',
    zhhbdw:'Đơn Vị Tiền Tệ Tài Khoản',
    ckqb:'Xem Tất Cả',
    anyue:'Theo Tháng',
    jidu:'Quý',
    bannian:'Nửa Năm',
    yinian:'1 Năm',
    ernian:'2 Năm',
    sanian:'3 Năm',
    jzye:'Giá Trị Thanh Lọc/Số Dư ($)',
    crj:'Nạp/Rút Tiền ($)',
    cj:'Rút Tiền',
    rj:'Nạp Tiền',
    ysyl:'Tỷ Suất Lợi Nhuận Theo Tháng',
    yiyue:'Tháng 1',
    eryue:'Tháng 2',
    sanyue:'Tháng 3',
    siyue:'Tháng 4',
    wuyue:'Tháng 5',
    liuyue:'Tháng 6',
    qiyue:'Tháng 7',
    bayue:'Tháng 8',
    jiuyue:'Tháng 9',
    shiyue:'Tháng 10',
    shiyiyue:'Tháng 11',
    shieryue:'Tháng 12',
    ccxj:'Tiết Vị Trí Giữ',
    cq:'Sản Phẩm',
    dk:'Đa/Không',
    ss:'Số Lô',
    yk2:'Lãi/Lỗ',
    hlzb:'Chỉ Số Đo Lường',
    ylddcxsjpj:'Thời Gian Giữ Vị Trí Đơn Hàng Lãi',
    ksddcxsjpj:'Thời Gian Giữ Vị Trí Đơn Hàng Lỗ',
    dgddylpj:'Lãi Mỗi Đơn Hàng Riêng Lẻ',
    dgddkspj:'Lỗ Mỗi Đơn Hàng Riêng Lẻ',
    dgddlrzd:'Lợi Nhuận Mỗi Đơn Hàng Riêng Lẻ',
    dgddkszd:'Lỗ Mỗi Đơn Hàng Riêng Lẻ',
    syl:'Tỷ Suất Lợi Nhuận',
    sjbl:'Tỷ Lệ Dữ Liệu',
    sl:'Tỷ Lệ Thắng',
    zdjybl:'Tỷ Lệ Giao Dịch Tự Động',
    pcddmx:'Chi Tiết Đơn Hàng Đóng Vị Trí',
    pcjg:'Giá Đóng Vị Trí',
    sxf:'Phí Dịch Vụ',
    tbxtccsc:'Hướng Dẫn Hoạt Động Hệ Thống Đồng Bộ',
    zhzc:'Đăng Ký Tài Khoản',
    xtdl:'Đăng Nhập Hệ Thống',
    jzhszwxh:'Cấu Hình Tài Khoản Thành Tín Hiệu？',
    sztbxh:'Cấu Hình Tín Hiệu Đồng Bộ', 
	
	
    wzjs:"JCLH将MT4或MT5下跨交易商多账户集中在平台内进行垂直管理，并为用户提供全部账户的数据汇聚、风险分析、财务汇总、信息分享和账户间数据同步的服务。",
    mzsmText:`<p  style="font-weight: bold; color: windowtext; text-align: center; ">
		<strong><span style="color: #ffffff; font-family: 微软雅黑; font-size: 22px;">
		免责声明</span>
		</strong>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">本声明是由 JCLH与在网站www.JCLH.biz上的已注册登记并已明确接受此等条款和条件的个人或公司共同签署。</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
		   <span>
				
				本网站已采取谨慎的措施对信息进行核实，但并不保证所含信息全部准确。请您理解我们的信息可能会不全面，或有疏漏或滞后。本网站或独立信息提供者均不会对任何因信息错误、不完整、迟延、不精确或基于对本网站信息的依赖而产生的损失承担任何责任。所有预测或观点(如未来汇率变动的预测)以及基于这些预测而进行的交易活动，仅代表第三方的个人观点和行为，并不代表本网站的立场。您须理解，第三方的预测不代表任何形式的业绩承诺，请不要直接或者间接地效仿。您必须进行独立分析以做出投资判断，同时应了解，在基于本网站内容做出判断所进行的投资行为可能产生实际的盈利或亏损。您基于本网站提供的交易策略和信号，运用个人配置交易系统所做出的投资行为是您自己决定的结果，需自行承担所有风险。</span></span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
		  
				
				本网站明确表明，本网站的管理平台仅适用于对高风险投资有一定了解的用户。您可以使用空闲的资金进行投资，而不应该影响到日常生活的开支。任何交易策略在过去取得的业绩均不能代表其将来的表现。一般未来汇率变动是不可预测的，这也就表明任何个人策略、金融顾问、手动或者自动交易系统都不能保证任何形式的预测可能产生利润，所以对待投资预测一定要经过自己的分析做出判断，切忌盲从。</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;"><span>基于网站或网络传输延时可能导致数据存在偏差（包括但不限于可能由于交易员修改密码或其他网络原因导致的账户断连造成订单跟随关系丢失），因此，用户在使用交易系统、交易跟随系统形成、产生交易后，应及时查看交易系统中交易数据的变化。无论是 JCLH 或是本网站任何合作伙伴都不能保证，您基于 JCLH 提供的信息及使用个人配置交易系统进行投资一定会盈利。除此之外， JCLH 作为跟随交易系统的开发者，不会对任何由于第三方(如作为这项服务的提供者公司或者交易商)延误、疏忽而导致的客户损失承担责任。除了以上， JCLH 明确表明不会对交易员提供的策略和交易信号承担任何责任。</span></span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
			
				JCLH 所属公司注册所在地法律、法规应适用于本声明以及管辖本声明各方之间引起的争议，除非存在法律指定适用其他管辖法律。</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
			
				在合约一方寻求实现本声明下的权利，或寻求宣告本声明下的任何权利或义务的任何民事诉讼或其他诉讼过程中，各合约方应承担其代理律师的费用和支出。合约方认可专属管辖和法院审判地。
			   
			</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">本声明的解释语言应为中文。</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">如果任何文件、信息和消息的非中文表述和中文表述之间出现矛盾和不一致的情况下，双方将以中文文件、信息和消息为标准。</span>
		</p>
	`,
    yszcText:`<p style="font-weight: bold; color: windowtext; text-align: center; ">
			<strong>
				<span style="color: #ffffff; font-family: 微软雅黑; font-size: 22px;">
					隐私政策
				</span>
			</strong>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">感谢您使用 JCLH ！</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				本《隐私政策》说明了我们如何收集、使用、处理和披露您的信息,包括与您访问和使用 JCLH 的个人信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				如果本《隐私政策》中有未定义的术语（如“服务项目”或“ JCLH ”），其定义和我们在服务条款中的定义一致。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				在本政策中，“ JCLH ”、“我们”或“我们的”指本《隐私政策》下对您的信息负责的 JCLH 公司。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1. 我们收集的信息类型
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

				我们主要收集三类信息。
			</span>
		</p>

		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

				1.1 您向我们提供的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

				使用 JCLH 的必要信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

				当您使用 JCLH 时，我们要求您提供并收集以下您的个人信息。此等信息对于充分履行您和我们之间的合同很有必要，并使得我们能够遵守我们的法律义务。没有此等信息，我们可能无法向您提供您所要求的全部服务。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1.1.1 账号信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				在您注册 JCLH 账号时，我们要求您提供用户昵称、手机号码、电子邮件地址、密码、头像等信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1.1.2 您选择向我们提供的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您可以选择向我们提供额外的个人信息，以便在使用 JCLH 时获得更好的用户体验。此等额外信息将基于您的自愿同意而处理。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				额外个人资料信息。您可选择提供额外个人资料信息，作为您个人资料的一部分（例如首选语言、国家和地区及个人描述）。如您在账号设置中所示，部分此等个人信息是您公开个人资料页的一部分，将向其他人公开。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				交易风控信息。您可选择提供设置账户交易时使用的风控策略。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				其他信息。您还可以选择在填写表格、进行搜索、更新或添加 JCLH 账号信息或使用 JCLH 的其他功能时，向我们提供其他信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1.2 您使用 JCLH 时，我们自动收集的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				在您使用 JCLH 时，我们会自动收集关于您所使用的服务以及如何使用相关服务的信息，包括个人信息。 基于我们合法的利益理由以提供和改进 JCLH ，此等信息对于充分履行您和我们之间的合同很有必要，使得我们能够遵守法律义务。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				登录数据和设备信息。即使您未创建或登录 JCLH 账号，当您访问并使用 JCLH 时，我们也会自动收集登录数据和设备信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				Cookies 及类似技术。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				Log-In Cookies : 当您使用“在此计算机自动登录”的功能时，我们会使用持久 Cookies 。在这种情况下， Cookies 文件将永久的保存在您的计算机硬盘上，除非您使用浏览器或操作系统软件手工将其删除。当您再次使用该网站时，网站就会通过读取这些 Cookies，得知您的相关信息，就可以做出自动登录的动作。这些 Cookies 包含一个 ID 号。您的登录资料和您的密码不会被保存。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1.3 我们通过第三方收集的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				第三方平台的交易账户信息。如果您将第三方交易账户连接至 JCLH，您将授权 JCLH 获取您的第三方平台的交易账户相关信息（比如：交易商信息、账户名、只读密码、交易数据等）。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				2.我们如何使用所收集的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				我们使用、存储和处理您的信息（包括个人信息），以提供、了解、改进和发展 JCLH ，创建和维护一个受到信任的、更安全的环境，并遵守我们的法律义务。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				2.1 创建和维护一个受到信任的以及更安全的环境
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				检测和预防欺诈、滥用、安全事件及其他有害活动。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				开展安全调查和风险评估。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				对照数据库与其他信息源进行检查，包括在适用法律允许的限度内以及必要时经您同意进行背景或警方调查。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				遵守我们的法律义务。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				解决我们与任何会员之间的任何争议，并执行我们与第三方的约定。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				执行我们的服务条款及其他政策。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				3.分享与披露
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				3.1 征得您的同意
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				经您同意，我们可以按照您在同意时的指示分享您的信息（包括个人信息），如当您授权第三方应用软件或网站访问您的 JCLH 账号时。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				3.2 业务转移
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				如果 JCLH 从事或涉及任何合并、收购、重组、资产出售、破产或者资不抵债的事件，那么我们可以出售、转让或分享我们的部分或全部资产，包括与此类交易或设想的此类交易(如尽职调查)有关的您的信息。在此情况下，我们会在转移您的个人信息且令其遵守不同隐私政策之前通知您。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				3.3汇总信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				出于遵守法规、行业与市场分析、受众统计归类、营销与广告以及其他业务目的，我们也会分享汇总信息（关于我们用户的合并信息，此类信息不再识别或指向某位个人用户）和其他匿名信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				4.其他重要信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				4.1 关联第三方账号
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您通过关联账号向我们提供的一些信息可能会被存储、处理和传输，用于欺诈防范和风险评估；以及对于您通过此类链接向 JCLH 提供的信息，其发布与显示取决于您在 JCLH 和第三方网站上的设置与授权。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				5.您的权利
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您可以联系我们，在相关 JCLH 数据控制人适用之前行使本条所述的任何权利。请注意，在对您的请求采取进一步行动之前，我们可能会要求您验证您的身份。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				5.1 管理您的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您可以通过您的账号设置访问和更新您的一些信息。您有责任及时更新您的个人信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				5.2 不准确或不完整的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您有权要求我们更正您的不准确或不完整的个人信息（以及您无法在您的 JCLH 账号中自行更新的信息）。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				5.4 数据保留与删除
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您可以向官方客服申请注销帐号或删除账户信息,工作人员会在3个工作日内处理。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				通常，我们只在履行您与我们之间的合同并遵守我们的法律义务的必要时间段内保留您的个人信息。如果您不再希望我们使用您的信息来为您提供 JCLH ，您可以要求我们删除您的个人信息并关闭您的 JCLH 账号。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				请注意，如果您申请删除您的个人信息：
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				我们可能会保留您的一些个人信息，以符合我们的合法商业利益，如欺诈侦测和预防以及提高安全性。例如，如果我们因欺诈或安全原因停用了 JCLH 账号，则我们可能会保留该 JCLH 账号的某些信息，以防止该会员将来再次创建新的 JCLH 账号。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				为了遵守我们的法律义务，我们可能会保留并使用您的个人信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				即使您的 JCLH 账号被注销，您与他人分享的信息仍可以在 JCLH 上公开显示。但您对这些信息的归属信息将被删除。此外，您的信息的某些副本（如登录记录）可能会保留在我们的数据库中，但会与个人标识符区分开来。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				6. 全球运营
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				为方便我们的全球运营， JCLH 可在我们的公司内部或与服务提供商转移、存储和处理您的信息。这些国家/地区的法律或许与您居住地所适用的法律不同。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				7.安全
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				我们将持续实施和更新管理、技术和物理安全措施，保护您的信息不受未经授权的访问、损失、破坏或变更。我们用来保护您的信息的一些安全措施是防火墙和数据加密以及信息访问控制。如果您知道或有理由相信您的 JCLH 账号信息已丢失、被盗用、被挪用或遭到其他方式入侵，或者出现任何实际或怀疑盗用您的 JCLH 账号的情况，请按照以下“联系我们”一条的说明联系我们。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				8.本《隐私政策》的变更
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				JCLH 保留随时根据本条规定修改本《隐私政策》的权利。如果我们对本《隐私政策》做出变更，我们将在 JCLH 上发布变更后的《隐私政策》，并更新《隐私政策》顶端的“最后更新”日期。如果您不同意变更后的《隐私政策》，您可以注销您的账号。如果您未在变更后的《隐私政策》生效前注销您的账号，您对 JCLH 的继续访问或使用将受变更后的《隐私政策》的约束。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				9.联系我们
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				如果您对本《隐私政策》或 JCLH 的信息处理方法有任何问题或意见，您可以通过官网在线客服与我们联系，或通过 JCLH 官方提供的各种联系方式与我们联系， JCLH 将给予您帮助。
			</span>
		</p>
	`,
	fwtkText:`<h1 style="text-align: center; line-height: normal; text-indent: 0em;">
		<span style="font-size: 22px;"><strong><span style="color: rgb(255, 255, 255); font-family: 微软雅黑;">服务条款</span></strong></span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;"><span>欢迎您使用</span> JCLH 网站的服务。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">您应当阅读并遵守《 JCLH 服务条款》(以下简称“本协议”)，请您务必审慎阅读、充分理解各项条款内容。除非您已充分阅读、完全理解并接受本所有条款内容，否则您无权使用 JCLH 服务。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">本协议是由 JCLH 与在网站 www.JCLH.biz 上的已注册登记并已明确接受此等条款和条件的个人或公司共同签署。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH多账户管理系统</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH多账户管理系统可以让您实现在云端管理多平台。用户可以通过JCLH管理、分析和汇总账户财务和风险。系统允许用户通过“Copy-Trading”的方式进行跨平台订单复制。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH不是不是经纪商或交易商，也不与任何金融机构有利益、介绍或居间关系。公司专注服务被传统金融市场忽略的一大部分客户：中小企业，个人客户。我们通过技术，让资产集合、风险管理、多账户管理、策略开发成为容易上手的业务。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">风险协议</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.考虑到交易存在巨大的风险，建议您在开户及交易前充分了解相关法律条规及咨询专业意见，根据个人的财务状况、投资经验、风险偏好等相关因素，慎重选择适合您的保证金交易产品。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2. JCLH 网站上所有信息（含文字、图片、音频、视频）均出于为公众传播有益资讯信息之目的，并不意味着 JCLH 赞同其观点或构成投资建议，且 JCLH 不会向您提供任何可依赖的投资建议。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">3.投资市场存在的风险是不受 JCLH 控制或影响的，您所有的交易均由个人承担风险。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">业绩统计服务</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.您应当理解，实际投资交易的收益/亏损百分比会随着各项因素而发生变化，如初始账户余额、市场行为、跟随者的账户设置等。因此，您在进行投资过程中实际产生的收益/亏损百分比可能与JCLH 多账户管理平台中信号提供者收益/亏损百分比存在一定的差异。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2. JCLH 不保证您所使用的信号提供者信号或本网站所传播的信息能让您获得利润而不亏损，您在 JCLH 多账户管理平台上进行保证金投资的实际收益/亏损均由您本人承担， JCLH 不承担任何相关责任。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">网上风险服务</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.您理解并同意，使用互联网的交易服务存在一些风险，包括硬件、软件或互联网连接等不可控因素，如信号强度、互联网的接收或路径、设备硬件或软件配置、或互联网连接的可靠性等不可控。 JCLH 不对网络交易中出现的通讯故障、误传或延误造成的损失负任何责任。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2.贵金属等全球金融产品投资市场的波动性或非流动性可能阻碍委托以有利的价格执行，或根本无法执行。如因市场情况或您的交易商的过错而导致交易无法执行，从而造成的任何损失、损害、成本或费用</span>(<span>包括但不限于，利润损失、使用损失、直接、间接、偶发或结果性损害</span>)<span>，</span> JCLH <span>不承担任何责任。</span></span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">外部链接服务</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">您理解并同意，通过 JCLH 网站链接到其他某些网站仅出于便利而提供。因这些网站所含的信息资料不可控制， JCLH 不对这些网站或您在这些网站找到的资料作出任何承诺。 JCLH 通往这些网站的链接信息，并不构成任何类型的认可或建议。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">适用法律和管辖权</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.JCLH所属公司注册所在地法律、法规应适用于本协议以及管辖本协议各方之间引起的争议，除非存在法律指定适用其他管辖法律。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2.在合约一方寻求实现本协议下的权利，或寻求宣告本协议下的任何权利或义务的任何民事诉讼或其他诉讼过程中，各合约方应承担其代理律师的费用和支出。合约方认可专属管辖和法院审判地。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">3.本协议的解释语言应为（简体）中文。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">4.如果任何文件、信息和消息的非中文表述和中文表述之间出现矛盾和不一致的情况下，双方将以中文文件、信息和消息为标准。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">其他</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">如果您对本条款有意见或建议，可与 JCLH 客服联系， JCLH 将给予您帮助。</span>
		</p>
		<p>
		<br/>
	</p>`,
	
	
	
    mzsmbt:"Tuyên Bố Miễn Trừ Trách Nhiệm",
	qwzxcz:"Để đảm bảo lợi nhuận theo dõi đơn tài khoản, vui lòng không tự thực hiện hoạt động!",
	wdzl:"Thông Tin Cá Nhân Của Tôi",
	wdqb:"Ví Của Tôi",
	hyfw:"Dịch Vụ Thành Viên",
	wdtd:"Đội Ngũ Của Tôi",
	tcdl:"Đăng Xuất",
	xhgl:"Quản Lý Tín Hiệu",
	sfgz:"Quy Tắc Phí: Định Giá Dựa Trên Tỷ Lệ 1:1 Giữa Tiền Và Tiền Tín Hiệu; Phí Đăng Ký Theo Dõi Của Người Dùng Cập Nhật Động, Trừ Theo Ngày。",
	jcdyf:"Phí Đăng Ký Theo Dõi Cơ Bản",
	yhdyf:"Phí Đăng Ký Theo Dõi Người Dùng",
	zhye:"Số Dư Tài Khoản",
	xhye:"Số Dư Tín Hiệu",
	yf:"Tháng",
	bkxzjygz:"Hiện Tại Không Được Chọn Quy Tắc Giao Dịch",
	bksrjycs:"Hiện Tại Không Được Nhập Tham Số Giao Dịch",
	hand:"Số Lô",
	pcjl:"Lịch Sử Đóng Vị Trí",
	tdxx:"Thông Tin Đội Ngũ",
	wdyqm:"Mã Mời Của Tôi",
	fz:"Sao Chép",
	yqmsjh:"Giới Thiệu Mã Mời/Số Điện Thoại",
	bangd:"Liên Kết",
	agree:"Tôi Đồng Ý",
	mzsm:"Tuyên Bố Miễn Trừ Trách Nhiệm",
	and:"và",
	fwtk:"Điều Khoản Dịch Vụ",
	qhyy:"Chuyển Đổi Ngôn Ngữ",
	zhong:"Tiếng Trung",
	ying:"Tiếng Anh",
	wei:"Tiếng Uyghur",
	tai:"Tiếng Thái",
	han:"Tiếng Hàn",
	ri:"Tiếng Nhật",
	
	kyye:"Số Dư JCLHoin Sẵn Sàng Dùng",
	yets:"JCLHoin Là Một Loại Token, Chỉ Có Thể Sử Dụng Trong Cộng Đồng JCLH, Không Được Chuyển Nhượng Giữa Người Dùng, Không Được Đổi Trả. Được Kinh Doanh Bởi JCLH. Thu Thập Thông Qua Quy Trình Đổi Điểm Mua. JCLHoin Có Thể Dùng Để Thanh Toán Phí Đăng Ký Theo Dõi, Đổi Giải Thưởng Và Hoạt Động Khác Trên Nền Tảng. Để Xem Chi Tiết, Hãy Tham Khảo 《Hiệp Định Mua Và Sử Dụng JCLHoin》",
	zffs:"Thức Thanh Toán",
	
	szhb:"Tiền Điện Tử",
	wxzf:"WeChat Pay",
	zfb:"Alipay",
	yl:"UnionPay",
	xyk:"Thẻ Tín Dụng",
	szjl:"Lịch Sử Thu và Chi",
	
	szsj:"Thời Gian",
	szsl:"Số Lượng",
	szxm:"Mục Đích",
	szzt:"Trạng Thái Đơn Hàng",
	szbh:"Số Đơn Hàng",
	
	dqdj:"Cấp Độ Hiện Tại",
	yxq:"Hiệu Lực Đến",
	shengj:"Nâng Cấp",
	hygm:"Chào Mừng Mua Thành Viên JCLH",
	zfje:"Số Tiền Thanh Toán",
	xfjl:"Lịch Sử Tiêu Dùng",
	xfje:"Số Tiền",
	
	dzgl:"Liên Quan",
	dzg:"cái",
	dzzh:"Tài Khoản",
	
	a1:'Số Lượng Mua',
	a2:'Cấp Độ Thành Viên',
	a3:'Số Lượng Tài Khoản',
	a4:'Thao Tác',
	a5:'Chứng Từ Chờ Tải Lên',
	a6:'Thanh Toán Thành Công',
	a7:'Thanh Toán Thất Bại',
	a8:'Tải Lên Chứng Từ',
	a9:'Xem Thanh Toán',
	a10:'Thanh Toán',
	a11:'Tiền Điện Tử',
	a12:'Địa Chỉ Ví',
	a13:'Sao Chép Địa Chỉ',
	a14:'Sao Chép Địa Chỉ Ví Để Thanh Toán',
	a15:'Mã QR',
	a16:'Số Tiền',
	a17:'Xác Định',
	a18:'Hủy',
	a19:'Đóng',
	a20:'Sao Chép Thành Công',
	a21:'Tải Lên Chứng Từ',
	a22:'Xem Chứng Từ',
	a23:'Chờ Duyệt',
	a24:'Tỷ Lệ Đảm Bảo',
	a25:'Tỷ Lệ Giá Trị Thanh Lọc',
	a26:'Tỷ Lệ Tiền Phương Tiện Sẵn Sàng Dùng',
	a27:'Tỷ Lệ Khối Lượng Giao Dịch',
	a28:'Tỷ Lệ Số Lô Cố Định',
	a29:'Theo Dõi Đơn Ngược Lại',
	a30:'Bồi Thường Mở Vị Trí',
	a31:'Bồi Thường Đóng Vị Trí',
	a32:'Đã Chọn',
	a33:'Có Mở Tài Khoản Hiện Tại Không',
	a34:'Có Tạm Dừng Tài Khoản Hiện Tại Không',
	a35:'Hoạt Động Đồng Bộ',
	a36:'Giới hạn một tài khoản',
	a37:'Không giới hạn số lượng mua tài khoản',
	
	a38:'Thành viên phiên bản dùng thử',
	a39:'Thành viên phiên bản cơ bản',
	a40:'Thành viên phiên bản chuyên nghiệp',
	a41:'Thành viên phiên bản tổ chức',
	a42:'Vui lòng thiết lập số điện thoại di động',
	a43:'Vui lòng thiết lập hộp thư điện tử',
	a44:'Vui lòng nhập mã mời',
	a45:'Hình ảnh đại diện tải lên chỉ có thể là định dạng JPG!',
	a46:'Kích thước hình ảnh đại diện tải lên không được vượt quá 2MB',
	a47:'Chưa có dữ liệu đồng bộ',
	a48:'Tổng số lô',
	a49:'Có đặt nó thành',
	a50:'Kích hoạt',
	a51:'Vô hiệu hóa',
	a52:'Trạng thái',
	a53:'Bạn có chắc chắn muốn xóa tài khoản này không?',
	a54:'Đã sao chép!',
	
	a55:'Vui lòng nhập tham số giao dịch',
	a56:'Mật khẩu mới không khớp với mật khẩu xác nhận!',
	a57:'Thu nhập hàng ngày',
	a58:'Trung bình',
	a59:'Tối đa',
	a60:'Làm mới thành công',
	a61:'Tỷ lệ sản xuất',
	a62:'Không đạt tiêu chuẩn',
	a63:'Đạt tiêu chuẩn',
	a64:'Tỷ lệ thắng',
	a65:'Rút tiền',
	a66:'Nạp tiền',
	a67:'Số dư',
	a68:'Giá trị ròng',
	a69:'Lãi/lỗ hàng ngày',
	a70:'Vui lòng nhập giá trị',
	a71:'Tín hiệu này chưa có người đồng bộ',
	
	a72:'Trạng thái đăng nhập đã hết hạn, vui lòng đăng nhập lại!',
	a73:'Tin nhắn SMS đã gửi, vui lòng chú ý kiểm tra và nhận.',
	a74:'Mã xác minh đã gửi!',
	a75:'Đăng nhập thành công!',
	a76:'Tên Người Dùng không được để trống',
	a77:'Số điện thoại di động không được để trống',
	a78:'Chưa đồng ý Thỏa thuận Người dùng và Chính sách Riêng tư',
	a79:'Nâng cấp Thành viên',
	a80:'Chọn Loại',
	a81:'Thời hạn hiệu lực hiện tại đến',
	a82:'Thời hạn hiệu lực tính toán đến',
	a83:'Ghi chú: Thời hạn hiệu lực sau tính toán được tính tự động bởi hệ thống.',
	a84:'Kéo tệp đến đây',
	a85:'Hoặc',
	a86:'Nhấp để tải lên',
	a87:'Bạn đã là thành viên cấp cao nhất, không thể nâng cấp tiếp.',
	a88:'Đang duyệt',
	a89:'Phương thức thanh toán này tạm thời không được hỗ trợ',
	a90:'Đặt lại mật khẩu',
	a91:'Đã nhớ ra',
	a92:'Hoa Kỳ',
	a93:'Trung Quốc',
	a94:'Hồng Kông',
	
	a95:'Cảnh báo Rủi ro',
	a96:'Cộng đồng Lượng hóa Trí tuệ này chủ yếu cung cấp tín hiệu giao dịch chuẩn hóa để người dùng tham khảo sử dụng.',
	a97:'Để đảm bảo hiệu quả chiến lược và kiểm soát sự chênh lệch thực thi',
	a98:'Khuyến nghị quy mô vốn cho một đối tượng lượng hóa không dưới 20000 USD',
	a99:'Nếu vốn đầu tư thấp hơn tiêu chuẩn này, có thể do quy mô vốn không đủ导致放大 rủi ro tương đối, ảnh hưởng đến sự ổn định của chiến lược.',
	a100:'Xin bạn trước khi bắt đầu bất kỳ thao tác nào, 务必 dựa trên tình hình tài chính và khả năng chịu đựng rủi ro của bản thân.',
	a101:'Thiết lập riêng cơ chế bảo vệ rủi ro cho tài khoản.',
	a102:'Tất cả hành vi giao dịch lượng hóa đều là quyết định độc lập của bạn, và các tổn thất gây ra bởi lãi lỗ liên quan 以及 các yếu tố bất khả kháng như biến động thị trường, sự cố hệ thống, thay đổi chính sách, v.v.',
	a103:'Tất cả đều do bạn tự chịu trách nhiệm.',
	a104:'Tín hiệu do cộng đồng này cung cấp chỉ dùng để tham khảo thông tin.',
	a105:'Không cấu thành khuyến nghị đầu tư, mời gọi mua bán hoặc bảo đảm.',
	a106:'Cộng đồng Lượng hóa Trí tuệ này',
	a107:'Không chịu trách nhiệm cho bất kỳ kết quả giao dịch hoặc tổn thất vốn nào.',
	a108:'Xin hiểu đầy đủ và xác nhận chấp nhận các rủi ro trên trước khi tiến hành thao tác.',
	a109:'Tôi đã hiểu',
	
	zhlb:'Danh sách tài khoản',
	
	a110:'Chưa có Cấp độ',
}
